export default function Select({ label, options = [], error, className = "", children, ...props }) {
  return (
    <label className="block">
      {label && <span className="block text-xs font-medium text-brand-slate mb-1">{label}</span>}
      <select
        className={`w-full px-3 py-2 border rounded-lg text-sm bg-white text-brand-ink focus:outline-none focus:ring-2 focus:ring-brand-blue/30 focus:border-brand-blue dark:bg-[var(--bg-soft)] dark:border-[var(--border-soft)] dark:text-[var(--text-primary)] ${error ? "border-red-400" : "border-gray-200"} ${className}`}
        {...props}
      >
        {children ||
          options.map((opt) =>
            typeof opt === "string" ? (
              <option key={opt} value={opt}>{opt}</option>
            ) : (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            )
          )}
      </select>
      {error && <span className="block text-xs text-red-600 mt-1">{error}</span>}
    </label>
  );
}
